import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  createThis2j2avj17cvnv2 as createThis,
  toString1pkumu07cwy4m as toString,
} from '../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { ensureNotNull1e947j3ixpazm as ensureNotNull } from '../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import {
  IllegalArgumentException2asla15b5jaob as IllegalArgumentException,
  IllegalStateExceptionkoljg5n0nrlr as IllegalStateException,
} from '../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { Unit_instance3vdlo4e4f5ggx as Unit_instance } from '../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { SegmentPool_instance1ixtbemlc1c8i as SegmentPool_instance } from './SegmentPool.mjs';
import { arrayCopytctsywo3h7gj as arrayCopy } from '../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        this.x3s_1 = 8192;
        this.y3s_1 = 1024;
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  return Companion_instance;
}
function init_okio_Segment(_this__u8e3s4) {
  _this__u8e3s4.a3t_1 = 0;
  _this__u8e3s4.b3t_1 = 0;
  _this__u8e3s4.c3t_1 = false;
  _this__u8e3s4.d3t_1 = false;
  _this__u8e3s4.e3t_1 = null;
  _this__u8e3s4.f3t_1 = null;
}
var SegmentClass;
function Segment() {
  if (SegmentClass === VOID) {
    class $ {
      static g3t() {
        var $this = createThis(this);
        init_okio_Segment($this);
        $this.z3s_1 = new Int8Array(8192);
        $this.d3t_1 = true;
        $this.c3t_1 = false;
        return $this;
      }
      static h3t(data, pos, limit, shared, owner) {
        var $this = createThis(this);
        init_okio_Segment($this);
        $this.z3s_1 = data;
        $this.a3t_1 = pos;
        $this.b3t_1 = limit;
        $this.c3t_1 = shared;
        $this.d3t_1 = owner;
        return $this;
      }
      i3t() {
        this.c3t_1 = true;
        return Segment().h3t(this.z3s_1, this.a3t_1, this.b3t_1, true, false);
      }
      j3t() {
        var result = !(this.e3t_1 === this) ? this.e3t_1 : null;
        ensureNotNull(this.f3t_1).e3t_1 = this.e3t_1;
        ensureNotNull(this.e3t_1).f3t_1 = this.f3t_1;
        this.e3t_1 = null;
        this.f3t_1 = null;
        return result;
      }
      k3t(segment) {
        segment.f3t_1 = this;
        segment.e3t_1 = this.e3t_1;
        ensureNotNull(this.e3t_1).f3t_1 = segment;
        this.e3t_1 = segment;
        return segment;
      }
      l3t(byteCount) {
        // Inline function 'kotlin.require' call
        if (!(byteCount > 0 && byteCount <= (this.b3t_1 - this.a3t_1 | 0))) {
          var message = 'byteCount out of range';
          throw IllegalArgumentException().n2(toString(message));
        }
        var prefix;
        if (byteCount >= 1024) {
          prefix = this.i3t();
        } else {
          prefix = SegmentPool_instance.o3t();
          var tmp0 = this.z3s_1;
          var tmp2 = prefix.z3s_1;
          var tmp5 = this.a3t_1;
          // Inline function 'kotlin.collections.copyInto' call
          var endIndex = this.a3t_1 + byteCount | 0;
          // Inline function 'kotlin.js.unsafeCast' call
          // Inline function 'kotlin.js.asDynamic' call
          var tmp = tmp0;
          // Inline function 'kotlin.js.unsafeCast' call
          // Inline function 'kotlin.js.asDynamic' call
          arrayCopy(tmp, tmp2, 0, tmp5, endIndex);
        }
        prefix.b3t_1 = prefix.a3t_1 + byteCount | 0;
        this.a3t_1 = this.a3t_1 + byteCount | 0;
        ensureNotNull(this.f3t_1).k3t(prefix);
        return prefix;
      }
      p3t() {
        // Inline function 'kotlin.check' call
        if (!!(this.f3t_1 === this)) {
          var message = 'cannot compact';
          throw IllegalStateException().o(toString(message));
        }
        if (!ensureNotNull(this.f3t_1).d3t_1)
          return Unit_instance;
        var byteCount = this.b3t_1 - this.a3t_1 | 0;
        var availableByteCount = (8192 - ensureNotNull(this.f3t_1).b3t_1 | 0) + (ensureNotNull(this.f3t_1).c3t_1 ? 0 : ensureNotNull(this.f3t_1).a3t_1) | 0;
        if (byteCount > availableByteCount)
          return Unit_instance;
        this.q3t(ensureNotNull(this.f3t_1), byteCount);
        this.j3t();
        SegmentPool_instance.r3t(this);
      }
      q3t(sink, byteCount) {
        // Inline function 'kotlin.check' call
        if (!sink.d3t_1) {
          var message = 'only owner can write';
          throw IllegalStateException().o(toString(message));
        }
        if ((sink.b3t_1 + byteCount | 0) > 8192) {
          if (sink.c3t_1)
            throw IllegalArgumentException().rd();
          if (((sink.b3t_1 + byteCount | 0) - sink.a3t_1 | 0) > 8192)
            throw IllegalArgumentException().rd();
          var tmp0 = sink.z3s_1;
          var tmp2 = sink.z3s_1;
          var tmp5 = sink.a3t_1;
          // Inline function 'kotlin.collections.copyInto' call
          var endIndex = sink.b3t_1;
          // Inline function 'kotlin.js.unsafeCast' call
          // Inline function 'kotlin.js.asDynamic' call
          var tmp = tmp0;
          // Inline function 'kotlin.js.unsafeCast' call
          // Inline function 'kotlin.js.asDynamic' call
          arrayCopy(tmp, tmp2, 0, tmp5, endIndex);
          sink.b3t_1 = sink.b3t_1 - sink.a3t_1 | 0;
          sink.a3t_1 = 0;
        }
        var tmp0_0 = this.z3s_1;
        var tmp2_0 = sink.z3s_1;
        var tmp4 = sink.b3t_1;
        var tmp6 = this.a3t_1;
        // Inline function 'kotlin.collections.copyInto' call
        var endIndex_0 = this.a3t_1 + byteCount | 0;
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp_0 = tmp0_0;
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        arrayCopy(tmp_0, tmp2_0, tmp4, tmp6, endIndex_0);
        sink.b3t_1 = sink.b3t_1 + byteCount | 0;
        this.a3t_1 = this.a3t_1 + byteCount | 0;
      }
    }
    initMetadataForClass($, 'Segment', $.g3t);
    SegmentClass = $;
  }
  return SegmentClass;
}
//region block: init
Companion_instance = new (Companion())();
//endregion
//region block: exports
export {
  Segment as Segmentnhwb43ukbiy3,
};
//endregion

//# sourceMappingURL=Segment.mjs.map
